import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ParDonorStatus from './par-donor-status';
import ParDonorStatusDetail from './par-donor-status-detail';
import ParDonorStatusUpdate from './par-donor-status-update';
import ParDonorStatusDeleteDialog from './par-donor-status-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ParDonorStatusUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ParDonorStatusUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ParDonorStatusDetail} />
      <ErrorBoundaryRoute path={match.url} component={ParDonorStatus} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ParDonorStatusDeleteDialog} />
  </>
);

export default Routes;
